import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=434770b7&scoped=true&"
import script from "./editAnnouncement.vue?vue&type=script&lang=js&"
export * from "./editAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./editAnnouncement.vue?vue&type=style&index=0&id=434770b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434770b7",
  null
  
)

export default component.exports